module.exports = __webpack_public_path__ + "static/media/RightAlignBlack.640c6c35.svg";